import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "country-switcher"
}
const _hoisted_2 = { class: "country-switcher__top-container" }
const _hoisted_3 = { class: "country-switcher__titles" }
const _hoisted_4 = { class: "channel-switcher__title" }
const _hoisted_5 = { class: "country-switcher__title" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "country-switcher__title" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "country-switcher__bottom-container" }

import { ref, watch, computed } from 'vue';
import useCountrySwitcher from '@/composables/useCountrySwitcher';
import useWebsiteTexts from '@/composables/useWebsiteTexts';


export default /*@__PURE__*/_defineComponent({
  __name: 'CountrySwitcher',
  props: {
  rowClass: {
    type: String,
    default: '',
  },
  iconClass: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props;

const { changeCountry, availableCountries } = useCountrySwitcher();
const { websiteText } = useWebsiteTexts();

const selectedCountry = ref<any>(null);
const selectedLanguage = ref<any>(null);

const selectedCountryId = ref('');
const selectedLanguageId = ref('');

const initialCountryId = ref('');
const initialLanguageId = ref('');


watch(availableCountries, (countries) => {
  if (countries?.length) {
    const current = countries.find(c => c.current) || countries[0];
    selectedCountry.value = current;
    selectedCountryId.value = current.id;
    initialCountryId.value = current.id;

    const currentLang = current.availableLanguages.find(l => l.current) || current.availableLanguages[0];
    selectedLanguage.value = currentLang;
    selectedLanguageId.value = currentLang.languageId;
    initialLanguageId.value = currentLang.languageId;
  }
}, { immediate: true });

watch(selectedCountryId, (id) => {
  const country = availableCountries.value.find(c => c.id === id);
  if (country) {
    selectedCountry.value = country;

    const currentLang = country.availableLanguages.find(l => l.current) || country.availableLanguages[0];
    selectedLanguage.value = currentLang;
    selectedLanguageId.value = currentLang.languageId;
  }
});


watch(selectedLanguageId, (id) => {
  const lang = selectedCountry.value?.availableLanguages.find(l => l.languageId === id);
  if (lang) selectedLanguage.value = lang;
});


const showConfirmButton = computed(() => {
  return selectedCountryId.value !== initialCountryId.value || selectedLanguageId.value !== initialLanguageId.value;
});


async function onConfirmChange() {
  try {
    const redirectUrl = await changeCountry(selectedCountryId.value, selectedLanguageId.value);
    if (redirectUrl) {
      window.location.assign(redirectUrl);
    } else {
      window.location.reload();
    }
  } catch (err) {
    alert(err);
  }
}

const getCountryDisplayName = (country: any) => country.displayName || country.channelName;
const getLanguageDisplayName = (language: any) => language.name || language.languageId;

return (_ctx: any,_cache: any) => {
  return (_unref(availableCountries).length > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(websiteText)('countryswitcher__changelocation').value), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(websiteText)('countryswitcher__choosepreference').value), 1)
          ]),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(websiteText)('countryswitcher__country').value), 1),
          _withDirectives(_createElementVNode("select", {
            class: _normalizeClass(['country-switcher__select', __props.rowClass]),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCountryId).value = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableCountries), (country) => {
              return (_openBlock(), _createElementBlock("option", {
                key: country.id,
                value: country.id
              }, _toDisplayString(getCountryDisplayName(country)), 9, _hoisted_6))
            }), 128))
          ], 2), [
            [_vModelSelect, selectedCountryId.value]
          ]),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(websiteText)('countryswitcher__language').value), 1),
          (selectedCountry.value?.availableLanguages?.length)
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 0,
                class: _normalizeClass(['country-switcher__select', __props.rowClass]),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedLanguageId).value = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedCountry.value.availableLanguages, (language) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: language.languageId,
                    value: language.languageId
                  }, _toDisplayString(getLanguageDisplayName(language)), 9, _hoisted_8))
                }), 128))
              ], 2)), [
                [_vModelSelect, selectedLanguageId.value]
              ])
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          (showConfirmButton.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: onConfirmChange,
                class: "confirm-btn"
              }, _toDisplayString(_unref(websiteText)('countryswitcher__location').value), 1))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})